import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../utils/UtilsFormule";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import UserService from "../services/PosService/UserService";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const DataTableManagersShop = ({
  managersShop,
  availableManagersToSelect,
  setAvailableManagersToSelect,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showBtnPlus, setShowBtnPlus] = useState(false);
  //alert
  const [infoAlertText, setInfoAlertText] = useState("");
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");

  //*****select
  const animatedComponents = makeAnimated();
  const [selectedOption, setSelectedOption] = useState([]);
  const onChangeSelectedOption = (selectedOption) => {
    setSelectedOption(selectedOption);
    // if (selectedOption.length > 0) {
    if (selectedOption != null) {
      // console.log(selectedOption);
      setShowBtnPlus(true);
    } else {
      setShowBtnPlus(false);
    }
  };

  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "firstName",
      text: "Nom & Prénom",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => `${row.firstName} ${row.lastName}`,
    },
    {
      dataField: "email",
      text: "Email",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "phoneNumber",
      text: "Numéro",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "address",
      text: "Adresse",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "id",
      text: "Actions",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
    },
  ];
  function buttonDeleteFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn btn-danger"
          onClick={(e) => {
            onDeleteManager(row?.id);
          }}
        >
          <i class="fas fa-trash"></i>
        </button>
      </span>
    );
  }
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ managersShop }) {
    return managersShop;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const onAddManagers = () => {
    // startLoading();
    // if (selectedOption.length == 0) {
    if (selectedOption == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("no Manager to add");
      return;
    } else {
      // const idsUsers = selectedOption.map((option) => option.id);
      const idUser = selectedOption.value;
      UserService.addManagersShop(
        localStorage.getItem("idMagasinManagers"),
        idUser
      )
        .then((response) => {
          if (response?.status == 200) {
            setOpenInfoAlert(true);
            setInfoAlertText(response?.data?.success);
            setSelectedOption([]);
            window.location.reload();
          } else if (response?.data?.error) {
            setErrorAlertText("error " + response?.data?.error);
          }
        })
        .catch((error) => {
          setErrorAlertText("error " + error);
        });
      // .finally(() => {
      //   stopLoading();
      // });
    }
  };
  const onDeleteManager = (idManager) => {
    // startLoading();
    UserService.deleteManagersShop(
      localStorage.getItem("idMagasinManagers"),
      idManager
    )
      .then((response) => {
        if (response?.status == 200 || response?.status == 201) {
          setOpenInfoAlert(true);
          setInfoAlertText(response?.data?.success);
          setSelectedOption([]);
          window.location.reload();
        } else if (response?.data?.error) {
          setErrorAlertText("error " + response?.data?.error);
        }
      })
      .catch((error) => {
        setErrorAlertText("error " + error);
      });
    // .finally(() => {
    //   stopLoading();
    // });
  };
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les directeurs de magasin</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={managersShop}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  />
                </div>
                <div
                  className="ml-auto mr-0"
                  style={{
                    width: "50%",
                    display: "flex",
                    gap: "8px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {showBtnPlus && (
                    <button
                      type="button"
                      class="btn btn-dark btn-sm"
                      style={{
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                      }}
                      onClick={onAddManagers}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </button>
                  )}

                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    // defaultValue={selectedOption}
                    onChange={onChangeSelectedOption}
                    // onInputChange={handleInputChange}
                    options={availableManagersToSelect}
                    placeholder={"Sélectionner le directeur à ajouter..."}
                    // isMulti
                  />
                </div>
              </div>
              <div className="row mt-2">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  // expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
        <Snackbar
          open={openSuccessAlert}
          autoHideDuration={2000}
          onClose={handleSuccessClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert
            variant="filled"
            onClose={handleSuccessClose}
            severity="success"
          >
            {successAlertText}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openErrorAlert}
          autoHideDuration={4000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleEroorClose} severity="error">
            {errorAlertText}
          </Alert>
        </Snackbar>
        {openInfoAlert && (
          <Snackbar
            open={openInfoAlert}
            autoHideDuration={2000}
            onClose={handleInfoClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <Alert variant="filled" onClose={handleInfoClose} severity="info">
              {infoAlertText}
            </Alert>
          </Snackbar>
        )}
      </div>
    </div>
  );
};
export default DataTableManagersShop;
